import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {Transient} from '../core/entity/core.entity.transient';
import {EnvironmentKind} from '../enum/environment.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {AssetEntity} from './asset.entity';
import {AssetGroupEntity} from './asset.group.entity';

@EntityTable('asset_group_xref', 'cf37909d-b5b8-4f3c-b337-d46383a2fb91')
export class AssetGroupXrefEntity extends Entity {

    @JoinColumn(FieldTypeKind.GUID, AssetGroupEntity, false, false, FieldRelationKind.BELONGS_TO, 'assetGroup', 'aliasId', 'assetGroupId')
    public assetGroupId: string;

    @JoinColumn(FieldTypeKind.GUID, AssetEntity, false, false, FieldRelationKind.BELONGS_TO, 'asset', 'aliasId', 'assetId')
    public assetId: string;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @Column(FieldTypeKind.DECIMAL)
    public index: number;

    @Transient()
    public asset: AssetEntity;

}
